/**
 * Sign Up Page
 * Redirects to booking page - self-serve signup is disabled for productized service model
 */

import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

const BOOKING_URL = "https://cal.com/scott-dudley-ftors8/15min";

export default function SignupPage() {
  // Redirect to booking page - signup is disabled for productized service
  useEffect(() => {
    window.location.href = BOOKING_URL;
  }, []);

  // Show a brief loading state while redirecting
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-gray-600">Redirecting to book a call...</p>
      </div>
    </div>
  );
}
